import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Table } from 'reactstrap';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import CreateNotificationModal from './CreateNotificationModal';
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from '../../../utils/Constants';
import { fetchPushNotifications } from '../../../actions';
import DeleteNotificationModal from './DeleteNotificationModal';

class AppNotificationScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            createNotificationModal: {
                show: false,
                isEdit: false,
                currentNotificationData: {

                }
            },
            deleteNotificationModal: {
                show: false,
                notificationId: null
            },
            size: DEFAULT_PAGE_SIZE,
            page: 0,
            resize: false
        };

        this.listenForResize = this.listenForResize.bind(this);
    }

    componentDidMount() {
        this.loadPushNotifications();

        window.addEventListener("resize", this.listenForResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.listenForResize);
    }

    listenForResize() {
        this.setState({
            ...this.state,
            resize: !this.state.resize
        });
    }

    loadPushNotifications() {
        this.props.fetchPushNotifications(this.props.brandId, this.state.page, this.state.size);
    }

    showCreatePushNotificationModal = (isEdit, currentNotificationData) => {
        this.setState({
            ...this.state,
            createNotificationModal: {
                ...this.state.createNotificationModal,
                show: true,
                isEdit: isEdit,
                currentNotificationData: currentNotificationData
            }
        });
    };

    hideCreatePushNotificationModal = (toRefresh) => {
        this.setState({
            ...this.state,
            createNotificationModal: {
                ...this.state.createNotificationModal,
                show: false
            }
        }, () => {
            if (toRefresh) {
                this.loadPushNotifications();
            }
        });
    };

    showDeleteNotificationModal = (notificationId) => {
        this.setState({
            ...this.state,
            deleteNotificationModal: {
                show: true,
                notificationId
            }
        });
    };

    hideDeleteNotificationModal = (toRefresh) => {
        this.setState({
            ...this.state,
            deleteNotificationModal: {
                ...this.state.deleteNotificationModal,
                show: false
            }
        }, () => {
            if (toRefresh) {
                this.loadPushNotifications();
            }
        });
    };

    handlePageChange = (pageNumber) => {
        this.setState({
            ...this.state,
            page: (pageNumber - 1)
        }, () => {
            this.loadPushNotifications();
        });
    };

    showNotificationStatus = (notificationStatus) => {
        switch (notificationStatus) {
            case 'PENDING':
                return (
                    <div style={{ color: '#000' }}>{i18n.t('screens:appNotificationsScreen.pending')}</div>
                );
            case 'SUCCESS':
                return (
                    <div style={{ color: '#759f2e' }}>{i18n.t('screens:appNotificationsScreen.sent')}</div>
                );
            default:
                return (
                    <div></div>
                );
        }
    };

    renderCreateBtn() {
        const { buttonHolder, createBtn } = styles;

        return (
            <div style={buttonHolder}>
                <Button onClick={() => this.showCreatePushNotificationModal(false)} style={createBtn} color="primary"> <MaterialIcon
                    icon="add_circle_outline" color="#fff"
                    size={20} />&nbsp;{i18n.t('common:buttons.createPushNotification')}
                </Button>
            </div>
        );
    }

    renderTable() {
        const { textOverflowEllipsis, textCenter, iconButtons } = styles;
        let calculatedWidth = window.innerWidth * 0.96 - 45;

        return (
            <Table borderless={true}>
                <thead>
                    <tr className="d-flex">
                        <th style={{ width: "13%" }}>{i18n.t('screens:appNotificationScreen.createdOn')}</th>
                        <th style={{ width: "13%", ...textCenter }}>{i18n.t('screens:appNotificationScreen.scheduledFor')}</th>
                        <th style={{ width: "17%" }}>{i18n.t('screens:appNotificationScreen.title')}</th>
                        <th style={{ width: "40%" }}>{i18n.t('screens:appNotificationScreen.body')}</th>
                        <th style={{ width: "10%", ...textCenter }}>{i18n.t('screens:appNotificationScreen.status')}</th>
                        <th style={{ width: "7%" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        this.props.appNotifications.content.map(notification => {
                            return (
                                <tr className="d-flex" style={{ width: "100%" }}>
                                    <td style={{ width: "13%" }}>{notification.dateTimeCreated}</td>
                                    <td style={{ width: "13%", ...textCenter }}>{notification.scheduled ? notification.dateTimeToPush : "Instant"}</td>
                                    <td style={{ width: `${calculatedWidth * 0.17}px`, ...textOverflowEllipsis }}>{notification.title}</td>
                                    <td style={{ width: `${calculatedWidth * 0.40}px`, ...textOverflowEllipsis }}>{notification.body}</td>
                                    <td style={{ width: "10%", ...textCenter }}>{this.showNotificationStatus(notification.pushNotificationStatus)}</td>
                                    <td style={{ width: "7%", display: 'flex' }}>
                                        <div style={iconButtons} onClick={() => this.showCreatePushNotificationModal(true, notification)}>
                                            {notification.pushNotificationStatus === 'SUCCESS' ?
                                                <MaterialIcon icon="file_copy" color="rgb(2, 136, 209)" />
                                                :
                                                <MaterialIcon icon="edit" color="rgb(2, 136, 209)" />
                                            }
                                        </div>
                                        <div style={iconButtons} onClick={() => this.showDeleteNotificationModal(notification.id)}>
                                            <MaterialIcon icon="delete" color="rgb(2, 136, 209)" />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </Table>
        );
    }

    render() {
        const { main, alignLeft } = styles;

        return (
            <React.Fragment>
                <div style={main}>
                    {this.renderCreateBtn()}
                    <br />
                    {this.renderTable()}

                    <div style={alignLeft}>
                        <Pagination
                            activePage={this.props.appNotifications.number + 1}
                            itemsCountPerPage={DEFAULT_PAGE_SIZE}
                            totalItemsCount={this.props.appNotifications.totalElements}
                            pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                            itemClass='page-item'
                            linkClass='page-link'
                            onChange={this.handlePageChange}
                        />
                    </div>
                </div>
                {this.state.createNotificationModal.show ?
                    <CreateNotificationModal
                        toggleModal={this.hideCreatePushNotificationModal}
                        modalData={this.state.createNotificationModal}
                        brandId={this.props.brandId}
                    />
                    : null}
                {this.state.deleteNotificationModal.show ?
                    <DeleteNotificationModal
                        toggleModal={this.hideDeleteNotificationModal}
                        modalData={this.state.deleteNotificationModal}
                    />
                    : null}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        appNotifications: state.appNotifications
    }
};

export default connect(mapStateToProps, { fetchPushNotifications })(AppNotificationScreen);

const styles = {
    main: {
        padding: '15px 30px 15px 15px'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    buttonHolder: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    createBtn: {
        alignSelf: 'flex-end'
    },
    textOverflowEllipsis: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    textCenter: {
        textAlign: 'center'
    },
    iconButtons: {
        margin: '0 8px',
        cursor: 'pointer'
    }
};


// WEBPACK FOOTER //
// ./src/components/brands/AppNotificationScreen/index.js